import * as React from "react";
const ChemicalIntermediatesSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m29.708 10.793-7.5-7.5a1 1 0 0 0-1.415 0L4.639 19.447a5.597 5.597 0 0 0 7.915 7.915l13.987-13.986 2.776-.925a1 1 0 0 0 .391-1.657ZM11.139 25.947a3.596 3.596 0 0 1-5.085-5.085l3.6-3.6c1.059-.363 2.719-.5 4.884.625 1.325.692 2.523 1 3.57 1.091l-6.969 6.969Zm14.545-14.395a1.001 1.001 0 0 0-.391.241l-4.946 4.947c-1.059.362-2.719.5-4.884-.625-1.325-.693-2.522-1-3.57-1.092L21.5 5.415l5.65 5.648-1.466.489Z"
    />
  </svg>
);
export default ChemicalIntermediatesSVG;
